import { combineReducers, Reducer, UnknownAction } from "redux";
import { Modules } from "../../types/index.js";
import actionModules from "./actionModules.js";
import byId from "./byId.js";
import byPageId from "./byPageId.js";
import byParentId from "./byParentId.js";
import bySiteModuleType from "./bySiteModuleType.js";
import modulesReducer from "./modules.js";

export const combined = combineReducers({
  byId,
  byParentId,
  byPageId,
  actionModules,
  bySiteModuleType,
});

const reducer: Reducer<Modules, UnknownAction> = (state, action) => {
  const stateFromAll = modulesReducer(state, action);
  return combined(stateFromAll, action);
};

export default reducer;
